import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { CreateTaskCategoryAddonInput, TaskCategoryAddonFilterInput, UpdateTaskCategoryAddonInput } from './inputs';
import { PriceResource, TaskCategoryAddonResource } from './resources';
import { TaskCategoryAddonRef } from './refs';

export default class TaskCategoryAddon {
    private basePath = '/api/task-category-addon';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of task category addons
    get = async (filter: TaskCategoryAddonFilterInput): Promise<CollectionResource<TaskCategoryAddonResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });
        const { data } = await this.http.get(`${this.basePath}/?${query}`);
        return data;
    };

    // Get single task category addon
    getById = async (id: ID): Promise<TaskCategoryAddonResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);
        return data;
    };

    // Create new task category addon
    create = async (input: CreateTaskCategoryAddonInput): Promise<TaskCategoryAddonRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Update task category addon
    update = async (id: ID, input: UpdateTaskCategoryAddonInput): Promise<TaskCategoryAddonRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);
        return data;
    };

    // Archive task category addon
    archive = async (id: ID): Promise<TaskCategoryAddonRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);
        return data;
    };

    // Restore archived task category addon
    restore = async (id: ID): Promise<TaskCategoryAddonRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);
        return data;
    };
}
